import { Progress } from "@/components/ui/progress";
import { MultiStageProgress } from "@/components/articles/MultiStageProgress";
import { cn } from "@/lib/utils";

interface ProgressBarProps {
  progress: number;
  stage?: string;
  className?: string;
  variant?: "simple" | "multi-stage";
  size?: "sm" | "md" | "lg";
  showPercentage?: boolean;
}

export function ProgressBar({
  progress,
  stage = "research",
  className,
  variant = "simple",
  size = "md",
  showPercentage = true,
}: ProgressBarProps) {
  const sizeClasses = {
    sm: "h-1.5",
    md: "h-2",
    lg: "h-3",
  };

  if (variant === "multi-stage") {
    const stages = [
      { label: "Research", percentage: 10, color: "bg-blue-500" },
      { label: "Data", percentage: 25, color: "bg-green-500" },
      { label: "Outline", percentage: 50, color: "bg-yellow-500" },
      { label: "Content", percentage: 75, color: "bg-yellow-500" },
      { label: "Image", percentage: 85, color: "bg-purple-500" },
    ];

    return (
      <div className={cn("space-y-1", className)}>
        <MultiStageProgress
          currentValue={progress}
          stages={stages}
          showStageLabels={false}
          stageHeight={sizeClasses[size]}
        />
        {showPercentage && (
          <div className="flex justify-between items-center text-xs text-muted-foreground">
            <span className="capitalize">{stage}</span>
            <span>{progress}%</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={cn("space-y-1", className)}>
      <Progress
        value={progress}
        className={sizeClasses[size]}
        indicatorClassName="transition-all duration-500"
      />
      {showPercentage && (
        <div className="flex justify-between items-center text-xs text-muted-foreground">
          <span className="capitalize">{stage}</span>
          <span>{progress}%</span>
        </div>
      )}
    </div>
  );
}

export default ProgressBar;
